import { render, staticRenderFns } from "./IdentityNumberDefault.vue?vue&type=template&id=56977a8c&"
import script from "./IdentityNumberDefault.vue?vue&type=script&lang=js&"
export * from "./IdentityNumberDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports